export default __webpack_public_path__ + "static/media/ruby.638d2e0c.png";